/**************************************************
 * Nombre:       Dialogo_Depocitar
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {WalletOutlined} from '@mui/icons-material'
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {useContext, useEffect, useRef, useState} from "react";
import {usuarioContext} from "../../App";
import Formulario_Retiro_Bonos from "../Formularios/Formulario_Retiro_Bonos";
import {theme} from "../../Tema";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {obtenerTotalBonos} from "../../CodigoCliente/Bonos/obtenerTotalBonos";
import {realizarRetiro} from "../../CodigoCliente/Retiros/realizarRetiro";
import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";
import {useNavigate} from "react-router";
import {realizarRetiroDeposito} from "../../CodigoCliente/Retiros/realizarRetiroDeposito";
import {crearDepositoDesdeBono} from "../../CodigoCliente/Depositos/crearDepositoDesdeBono";
import {pagarFeeDeposito} from "../../CodigoCliente/Depositos/pagarFeeDeposito";
import {debounce} from "lodash";

const Dialogo_Retiro_Bonos = ({cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const navigate = useNavigate()
    const [cargando, setCargando] = useState(false)
    const [totalBonos, setTotalBonos] = useState(0);
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {tipo: 'LTC RED (LITECOIN)'}})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logo,
    })



    const subirDatos = () =>{
        setCargando(true)
        enviarDatos().then(() =>{
            setCargando(false)
        })
    }

    const enviarDatos = async () => {

        let entidad = await obtenerEntidad()
        let totBons = await obtenerTotalBonos(cData.usuario.id)

        if (!entidad.destino) {
            terminar({aviso: 'Escoge el destino para continuar', variante: 'error'})
            return
        }


        if (entidad.valor <= 0) {
            terminar({aviso: 'Coloca un valor positivo', variante: 'error'})
            return
        }

        if (entidad.valor > totBons) {
            terminar({aviso: 'No posees suficiente dinero en Bonos', variante: 'error'})
            return
        }

        if (entidad.valor < 15) {
            terminar({aviso: 'El retiro minimo es de 15 USD', variante: 'error'})
            return
        }

        iniciarCarga('Generando Retiro')
        setCargando(true)

        if (entidad.destino === 'Wallet de Deposito') {
            let valorDeposito = entidad.valor
            //  console.log(valorDeposito)
            await realizarRetiroDeposito({valor: entidad.valor, usuario: cData.usuario, desde: 'Bono'})
            await crearDepositoDesdeBono({
                entidad: entidad,
                usuario: cData.usuario,
                desde: 'Bono',
                valor: valorDeposito
            })
            await pagarFeeDeposito({entidad: entidad, usuario: cData.usuario, desde: 'Bono'})

        } else {
            await realizarRetiro({
                usuario: cData.usuario,
                valor: entidad.valor,
                desde: 'Bono',
                metodo: entidad.metodo,
                billetera: entidad.billetera
            })
        }

        if (entidad.billetera !== cData.usuario.billetera) {
            await actualizarDoc('cuentas', cData.usuario.id, {billetera: entidad.billetera})
        }


        setCargando(false)
        navigate('/Historial')
        terminar({aviso: 'Solicitud de retiro realizada con exito'})
        cerrar()

    }

    useEffect(() => {
        obtenerTotalBonos(cData.usuario.id).then((dox) => {

            setTotalBonos(dox);
        })

        setEntidad({billetera: cData.usuario.billetera, tipo: 'LTC RED (LITECOIN)'})


    }, [cData.usuario]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center',}}>
                <Typography sx={{fontSize: 16, fontWeight: 400}}>Total en Bonos</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -2.5}}>
                <Typography sx={{fontSize: 24, fontWeight: 600, color: theme.palette.primary.main}}>
                    {`${formatoMonedaTabla(totalBonos, 2)} USD`}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Formulario_Retiro_Bonos props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: 2}}>
                <Button
                    loading={cargando}
                    onClick={() => subirDatos()}
                    startIcon={<WalletOutlined/>}>Solicitar Retiro</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Retiro_Bonos